import Repository from "./Repository";
import { AxiosResponse } from "axios";
import type { Activity } from "@/models/wellness/Activity";
import type { WellnessActivityType } from "@/models/wellness/WellnessActivityType";
import type { WellnessCalculationRequest } from "@/models/wellness/WellnessCalculationRequest";
import type { WellnessCalculationResult } from "@/models/wellness/WellnessCalculationResult";

const resource = "/wellness";

export default {
  listActivityTypes(): Promise<AxiosResponse<WellnessActivityType[]>> {
    return Repository.get<WellnessActivityType[]>(
      `${resource}/ListActivityTypes`,
      { withCredentials: true },
    );
  },
  listActivities(
    activityTypeId?: number,
    search?: string,
  ): Promise<AxiosResponse<Activity[]>> {
    const params: string[] = [];

    if (activityTypeId) {
      params.push(`activityTypeId=${encodeURIComponent(activityTypeId)}`);
    }

    if (search) {
      params.push(`search=${encodeURIComponent(search)}`);
    }

    const query = params.length > 0 ? `?${params.join("&")}` : "";
    return Repository.get<Activity[]>(`${resource}/ListActivities${query}`, {
      withCredentials: true,
    });
  },
  calculate(
    request: WellnessCalculationRequest,
  ): Promise<AxiosResponse<WellnessCalculationResult[]>> {
    return Repository.post<WellnessCalculationResult[]>(
      `${resource}/Calculate`,
      request,
      { withCredentials: true },
    );
  },
};
